"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/UnsubscribeEmailNotifsScreen.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _errors = require('shared/errors');
var _Spinner = require('web/components/Spinner'); var _Spinner2 = _interopRequireDefault(_Spinner);
var _AuthFrame = require('web/components/AuthFrame');





const backToBloomText = (
  _react2.default.createElement('div', { className: "auth-links", __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}
    , _react2.default.createElement('a', { href: "/", className: "auth-link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}, "Back to BloomText"  )
  )
)

const UnsubscribeEmailNotifsScreen = ({ match }) => {
  const [stage, setStage] = _react.useState('loading')

  // Runs once on mount with the route params at that time, as before.
  _react.useEffect.call(void 0, () => {
    const token = match.params.token
    const email = match.params.email
    _client2.default.unsubscribeEmailNotifs(email, token).then(() => {
      setStage('success')
    }).catch((err) => {
      if (err instanceof _errors.RestError) {
        err = err.response
      }
      switch (err.Error) {
        case 'Invalid Token':
          setStage('invalid_token')
          break
        case 'Server Error':
          setStage('server_error')
          break
        default:
          setStage('server_error')
          break
      }
    })
    // Mount-only, as componentDidMount was.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let body = null
  switch (stage) {
    case 'loading':
      body = (
        _react2.default.createElement('div', { className: "auth-stack auth-loading" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
          , _react2.default.createElement(_Spinner2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 52}} )
          , _react2.default.createElement('h1', { className: "auth-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "BloomText is working…"  )
        )
      )
      break
    case 'success':
      body = (
        _react2.default.createElement(_AuthFrame.ResultCard, { tone: "ok", title: "You're unsubscribed" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
          , _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}, "Success! BloomText has unsubscribed you from email notifications."       )
          , _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}, "To reactivate email notifications, turn them on in your notification settings."          )
          , _react2.default.createElement(_reactrouterdom.Link, { className: "blm-btn blm-btn--primary" , to: "/login", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}, "Log in" )
        )
      )
      break
    case 'server_error':
      body = (
        _react2.default.createElement(_AuthFrame.ResultCard, { tone: "bad", title: "Something went wrong"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
          , _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, "Sorry, BloomText has encountered an error. Please try again later or contact support@bloomtext.com."

          )
          ,  backToBloomText 
        )
      )
      break
    case 'invalid_token':
      body = (
        _react2.default.createElement(_AuthFrame.ResultCard, { tone: "bad", title: "This link is invalid"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
          , _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}, "Sorry, this link is invalid. Please try again later or contact support@bloomtext.com."

          )
          ,  backToBloomText 
        )
      )
      break
  }

  return (
    _react2.default.createElement(_AuthFrame.AuthFrame, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}
      ,  body 
    )
  )
}

exports. default = UnsubscribeEmailNotifsScreen
